import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-chat-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17784_448)">
        <path
          d="M19.9993 5.33317V14.6665H6.89268L5.33268 16.2265V5.33317H19.9993ZM21.3327 2.6665H3.99935C3.26602 2.6665 2.66602 3.2665 2.66602 3.99984V22.6665L7.99935 17.3332H21.3327C22.066 17.3332 22.666 16.7332 22.666 15.9998V3.99984C22.666 3.2665 22.066 2.6665 21.3327 2.6665ZM27.9993 7.99984H25.3327V19.9998H7.99935V22.6665C7.99935 23.3998 8.59935 23.9998 9.33268 23.9998H23.9993L29.3327 29.3332V9.33317C29.3327 8.59984 28.7327 7.99984 27.9993 7.99984Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17784_448">
          <rect width="32" height="32" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatIconComponent {}
